/**
 * Finishing - Google Map
 *
 * JS pour la gestion du Google Map
 *
 * @since       04.08.2015
 * @version     1.0.0.0
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/***********************************************/
/********** INITILISATION DE LA CARTE **********/
/***********************************************/

function googleMapInitialize() {

    /**********************************************/
    /********** DÉFINITION DES VARIABLES **********/
    /**********************************************/

    var map;

    var country = new google.maps.LatLng(46.818188, 8.227512);
    var bounds = new google.maps.LatLngBounds();

    var image = data_sage_js.siteurl + '/wp-content/themes/finishing/dist/images/markers/map-marker-min.png';

    console.info(image);

    var markers = [
        ['Allemagne', 51.165691, 10.451526],
        ['Chine', 35.861660, 104.195397],
        ['Corée du Sud', 35.907757, 127.766922],
        ['Dubaï', 25.204849, 55.270783],
        ['Etats-Unis', 37.090083, -95.712869],
        ['France', 46.227638, 2.213749],
        ['Grèce', 39.074208, 21.824312],
        ['Inde', 20.593684, 78.962880],
        ['Italie', 41.871940, 12.567380],
        ['Malaisie', 4.210484, 101.975766],
        ['Maurice', -20.348404, 57.552152],
        ['Portugal', 39.399872, -8.224454],
        ['Roumanie', 45.943161, 24.966760],
        ['Royaume-Uni', 55.378051, -3.435973],
        ['Suisse', 46.818188, 8.227512],
        ['Thaïlande', 15.870032, 100.992541],
        ['Vietnam', 14.058324, 108.277199],
    ];

    var infoWindowContent = [
        '<div class="info_content">Allemagne</div>',
        '<div class="info_content">Chine</div>',
        '<div class="info_content">Corée du Sud</div>',
        '<div class="info_content">Dubaï</div>',
        '<div class="info_content">Etats-Unis</div>',
        '<div class="info_content">France</div>',
        '<div class="info_content">Grèce</div>',
        '<div class="info_content">Inde</div>',
        '<div class="info_content">Italie</div>',
        '<div class="info_content">Malaisie</div>',
        '<div class="info_content">Maurice</div>',
        '<div class="info_content">Portugal</div>',
        '<div class="info_content">Roumanie</div>',
        '<div class="info_content">Royaume-Uni</div>',
        '<div class="info_content">Suisse</div>',
        '<div class="info_content">Thaïlande</div>',
        '<div class="info_content">Vietnam</div>',
    ];

    var centerBounds = false;
    var drag = true;

    if (window.matchMedia('(max-width: 1025px)').matches) {

        drag = false;

    //END if (window.matchMedia('(min-width: 1025px)').matches
    }

    /********************************************/
    /********** GÉNÉRATION DE LA CARTE **********/
    /********************************************/

    var mapStyles = [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "hue": "#ff0000"
                }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "gamma": "0.40"
                }
            ]
        },
        {
            "featureType": "landscape.natural.terrain",
            "elementType": "geometry",
            "stylers": [
                {
                    "gamma": "1"
                }
            ]
        },
        {
            "featureType": "landscape.natural.terrain",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "gamma": "1.00"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dedede"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e9e9e9"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "gamma": "10.00"
                },
                {
                    "lightness": 16
                },
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ];

    var mapOptions = {
        mapTypeId: 'roadmap',
        scrollwheel: false,
        panControl: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        overviewMapControl: false,
        rotateControl: false,
        draggable: drag,
        center: new google.maps.LatLng(46.818188, 8.227512),
        zoom: 2,
        styles: mapStyles
    };

    map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions); 

    /*****************************/
    /********** MARKERS **********/
    /*****************************/

    var infoWindow = new google.maps.InfoWindow(), marker, i;
	
	var setInfos = function( map, info, marker ) {

        return function() {
            infoWindow.setContent( info );
            infoWindow.open( map, marker );
        };

    };

    for ( i = 0; i < markers.length; i++ ) {

        var position = new google.maps.LatLng(markers[i][1], markers[i][2]);


        if ( centerBounds === true ) {
            bounds.extend(position);
        }

        marker = new google.maps.Marker({
            position: position,
            map: map,
            title: markers[i][0],
            icon: image
        });

        google.maps.event.addListener( marker, 'click', setInfos( map, infoWindowContent[i], marker ) );

        if ( centerBounds === true ) {
            map.fitBounds(bounds);
        }

    //END for ( i = 0; i < markers.length; i++ )
    }

    /**************************/
    /********** ZOOM **********/
    /**************************/

    if ( centerBounds === true ) {

        var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
            this.setZoom(8);
            google.maps.event.removeListener(boundsListener);
        });

    //END if ( centerBounds == true )
    }

//END googleMapInitialize
}

/********************************************************************************/
/********************************************************************************/

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery(document).ready(function() {

    if ( jQuery('#map_canvas').length > 0 ) {

        googleMapInitialize();

    //END if ( jQuery('#map_canvas').length > 0 )
    }

//END jQuery(document).ready
});
